export default __webpack_public_path__ + "static/media/no_avatar.97e54aea.svg";